import type { OnboardingPublic } from '@scriptpad/shared';
import { Step1Welcome } from './Step1Welcome.js';
import { Step2Practice } from './Step2Practice.js';
import { Step3OrgInstructions } from './Step3OrgInstructions.js';
import { Step3SoleGovernance } from './Step3SoleGovernance.js';
import { Step4OrgUpload } from './Step4OrgUpload.js';
import { Step5HpiI } from './Step5HpiI.js';
import { Step6Identity } from './Step6Identity.js';
import { Step7Complete } from './Step7Complete.js';

export interface WizardStepProps {
  guid: string;
  data: OnboardingPublic;
  onAdvance: (next: number) => void;
  onPatched: (data: OnboardingPublic) => void;
}

interface WizardRouterProps extends WizardStepProps {}

export const WizardRouter = (props: WizardRouterProps) => {
  const { data } = props;
  switch (data.currentStep) {
    case 1:
      return <Step1Welcome {...props} />;
    case 2:
      return <Step2Practice {...props} />;
    case 3:
      return data.practiceMode === 'sole_practitioner' ? (
        <Step3SoleGovernance {...props} />
      ) : (
        <Step3OrgInstructions {...props} />
      );
    case 4:
      return <Step4OrgUpload {...props} />;
    case 5:
      return <Step5HpiI {...props} />;
    case 6:
      return <Step6Identity {...props} />;
    case 7:
    default:
      return <Step7Complete {...props} />;
  }
};
